import React, { Component } from 'react';
import { Row, Col, Icon } from 'antd';

export default class YourAccountLoadingIndicator extends Component {
    constructor(props) { super(props); }
    render() {
        return (
            <Row type='flex' justify='space-around' align='middle'>
                <Col>
                    <div>
                        <div>
                            <Icon type="loading" style={{ fontSize: '36px' }} />
                        </div>
                        <div style={{ marginLeft: '-10px' }}>
                            <span style={{ fontStyle: 'italic' }}>
                                {'Loading...'}
                            </span>
                        </div>
                    </div>
                </Col>
            </Row>
        );
    }
}
